// Detect if user is from the UK and show a popup to redirect to .co.uk
(function () {
    let countryCode = "";

    function getVisitorCountry() {
        return fetch("https://ipapi.co/json/")
            .then((res) => res.json())
            .then((data) => {
                return (countryCode = data.country_code); // "GB" or "US"
            })
            .catch(function () {
                return null;
            });
    }

    getVisitorCountry().then(function (countryCode) {
        const showUK = countryCode === "GB";
        const showUS = countryCode === "US";

        if (showUK || showUS) {
            document.querySelectorAll(".selected-value__comparison").forEach(function (wrapper) {
                if (showUK) {
                    document.querySelectorAll(".size-comparison--uk").forEach(function (el) {
                        el.classList.add("size-comparison--active");
                    });
                }
                if (showUS) {
                    document.querySelectorAll(".size-comparison--us").forEach(function (el) {
                        el.classList.add("size-comparison--active");
                    });
                }
            });
        }
    });
})();
